import React from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';
import { Mutation } from 'react-apollo';
import DocumentTableRow from './DocumentTableRow';

const DocumentTable = ({
  documents,
  onEdit,
  onDelete,
  onDownload,
  onView,
  onToggleShare,
}) => {
  const intl = useIntl();

  return (
    <div className="mt-4">
      <div className="bg-succession-bg-primary border border-succession-border rounded-lg overflow-hidden w-full">
        <div className="overflow-x-auto">
          <table className="w-full" style={{ tableLayout: 'fixed' }}>
            <thead>
              <tr className="border-b border-succession-border" style={{ background: 'var(--succession-bg-tertiary)' }}>
                <th className="py-3 px-4 font-semibold text-sm text-succession-text-primary text-left" style={{ width: '25%' }}>
                  {intl.formatMessage({ id: 'succession.vault.table_title' })}
                </th>
                <th className="py-3 px-4 font-semibold text-sm text-succession-text-primary text-left" style={{ width: '25%' }}>
                  {intl.formatMessage({ id: 'succession.vault.table_description' })}
                </th>
                <th className="py-3 px-4 font-semibold text-sm text-succession-text-primary text-left" style={{ width: '12%' }}>
                  {intl.formatMessage({ id: 'succession.vault.table_category' })}
                </th>
                <th className="py-3 px-4 font-semibold text-sm text-succession-text-primary text-left" style={{ width: '15%' }}>
                  {intl.formatMessage({ id: 'succession.vault.table_tags' })}
                </th>
                <th className="py-3 px-4 font-semibold text-sm text-succession-text-primary text-center" style={{ width: '10%' }}>
                  {intl.formatMessage({ id: 'succession.vault.table_sharing' })}
                </th>
                <th className="py-3 px-4 font-semibold text-sm text-succession-text-primary text-right" style={{ width: '13%' }}>
                  {intl.formatMessage({ id: 'succession.vault.table_actions' })}
                </th>
              </tr>
            </thead>
            <tbody>
              {documents.map(document => (
                <Mutation key={document.id} mutation={onToggleShare.mutation}>
                  {toggleShareMutation => (
                    <Mutation mutation={onDelete.mutation}>
                      {deleteMutation => (
                        <DocumentTableRow
                          document={document}
                          onEdit={() => onEdit(document)}
                          onDelete={() => {
                            if (window.confirm(intl.formatMessage({ id: 'succession.vault.delete_confirm' }, { title: document.title }))) {
                              deleteMutation({
                                variables: { id: document.id },
                              }).then(() => {
                                onDelete.onSuccess();
                              }).catch(error => {
                                console.error('Error deleting document:', error);
                              });
                            }
                          }}
                          onDownload={() => onDownload(document)}
                          onView={() => onView(document)}
                          onToggleShare={(doc, isShared) => {
                            toggleShareMutation({
                              variables: {
                                id: doc.id,
                                shared_with_negotiating: isShared,
                              },
                            }).then(() => {
                              onToggleShare.onSuccess();
                            }).catch(error => {
                              console.error('Error updating sharing:', error);
                            });
                          }}
                        />
                      )}
                    </Mutation>
                  )}
                </Mutation>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

DocumentTable.propTypes = {
  documents: PropTypes.array.isRequired,
  onEdit: PropTypes.func.isRequired,
  onDelete: PropTypes.shape({
    mutation: PropTypes.object.isRequired,
    onSuccess: PropTypes.func.isRequired,
  }).isRequired,
  onDownload: PropTypes.func.isRequired,
  onView: PropTypes.func.isRequired,
  onToggleShare: PropTypes.shape({
    mutation: PropTypes.object.isRequired,
    onSuccess: PropTypes.func.isRequired,
  }).isRequired,
};

export default DocumentTable;
